"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tabSourcesSelector = void 0;
var _sources = require("@studio/sources");
var _constants = require("@studio/constants");
var _reselect = require("reselect");
var _sources2 = require("../utils/sources");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function selectTab(state) {
  return state.tabs.currentTab;
}
function selectFeaturedPresenter(state) {
  return state.featuredPresenter;
}
function selectAttendeeMuteStatus(state) {
  return state.attendeeMuteStatus;
}
function selectBroadcastSources(state) {
  return state.broadcastSources.sources;
}

/**
 * @param {Array} sources
 * @param {Array} sourceTypes
 */
function filterSources(sources, sourceTypes) {
  return sources === null || sources === void 0 ? void 0 : sources.filter(function (source) {
    return sourceTypes.includes(source.type);
  });
}

/**
 * @param {Array} sources
 * @param {string} featuredPresenter
 */
function addFeaturedPresenter(sources, featuredPresenter) {
  var featuredPresenterIndex = sources === null || sources === void 0 ? void 0 : sources.findIndex(function (source) {
    return source.type === _constants.CAMERA_PRESENTER && source._id === featuredPresenter;
  });
  if (featuredPresenterIndex > -1) {
    // We have a featured presenter
    sources[featuredPresenterIndex].featured = true;
  }
  return sources;
}
var tabSourcesSelector = exports.tabSourcesSelector = (0, _reselect.createSelector)([selectTab, selectBroadcastSources, selectAttendeeMuteStatus, selectFeaturedPresenter], function (currentTab, sources, attendeeMuteStatus, featuredPresenter) {
  if (currentTab === 'speakers') {
    var presenterSources = filterSources(sources, [_constants.SCREEN_PRESENTER, _constants.CAMERA_PRESENTER]).map(function (source) {
      var sourceValue = (0, _sources.getSourceValue)(source);
      return _objectSpread(_objectSpread({}, source), {}, {
        muted: !!attendeeMuteStatus[sourceValue]
      });
    });
    var orderedPresenterSources = (0, _sources2.orderSources)(presenterSources);

    // Screen Share source should always be at the beginning of the source list items
    var combinedSources = filterSources(orderedPresenterSources, [_constants.SCREEN_PRESENTER]).concat(filterSources(orderedPresenterSources, [_constants.CAMERA_PRESENTER]));
    return addFeaturedPresenter(combinedSources, featuredPresenter);
  }
  if (currentTab === _constants.MEDIA) {
    var mediaSources = filterSources(sources, [_constants.MEDIA, _constants.AUDIO_FILE, _constants.VIDEO_FILE, _constants.IMAGE_FILE, _constants.PDF_FILE]);
    return (0, _sources2.orderSources)(mediaSources);
  }
  return filterSources(sources, [currentTab]);
});